import arrowCTA from "images/arrowUpRight.svg"
import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"

export default function Centralize() {
	return (
		<>
			<Leg>
				<Arrow src={arrowCTA} alt="" />
				<Circle />
			</Leg>
			<Leg>
				<Arrow src={arrowCTA} alt="" />
				<Circle />
			</Leg>
			<Leg>
				<Arrow src={arrowCTA} alt="" />
				<Circle />
			</Leg>
			<Leg>
				<Arrow src={arrowCTA} alt="" />
				<Circle />
			</Leg>
			<Main>
				<Arrow src={arrowCTA} alt="" />
				<Arrow src={arrowCTA} alt="" />
				<Arrow src={arrowCTA} alt="" />
				<Arrow src={arrowCTA} alt="" />
				<Circle />
			</Main>
		</>
	)
}

const slideToUpRight = keyframes`
    0% {
        translate: var(--translate);
    }

    85% {
        translate: var(--translate);
        animation-timing-function: ${eases.quart.inOut};
    }
    
    100% {
        translate: 0 0;
    }
`

const shrink = keyframes`
    0% {
        scale: 1;
    }
    85% {
        scale: 1;        
        animation-timing-function: ${eases.quart.in};
    }
    95% {
        scale: 0;
    }
    100% {
        scale: 0;
    }
`

const Arrow = styled.img`
	${fresponsive(css`
		width: 12px;
		height: 12px;
	`)}
`

const Circle = styled.div`
	outline: 1px solid ${colors.blue3};
	${fresponsive(css`
		width: 10px;
		height: 10px;
		border-radius: 50%;
	`)}
`

const Leg = styled.div`
	animation: ${slideToUpRight} 10s infinite;

	${fresponsive(css`
		width: 25.5px;
		height: 25.5px;
		position: absolute;
		--offset: 26.5px;

		&:nth-child(1) {
			top: var(--offset);
			right: var(--offset);
			--translate: -50px 50px;
		}

		&:nth-child(2) {
			top: var(--offset);
			left: var(--offset);
			rotate: -90deg;
			--translate: 50px 50px;
		}

		&:nth-child(3) {
			bottom: var(--offset);
			right: var(--offset);
			rotate: 90deg;
			--translate: -50px -50px;
		}

		&:nth-child(4) {
			bottom: var(--offset);
			left: var(--offset);
			rotate: 180deg;
			--translate: 50px -50px;
		}
	`)}

	${Arrow} {
		position: absolute;
		bottom: 0;
		left: 0;
	}

	${Circle} {
		position: absolute;
		top: 0;
		right: 0;
	}
`

const Main = styled.div`
	position: relative;
	animation: ${shrink} 10s infinite;
	transform-origin: center;

	${fresponsive(css`
		width: 41px;
		height: 41px;
		top: calc(50% - 20.5px);
		left: calc(50% - 20.5px);
	`)}

	${Circle} {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	${Arrow} {
		position: absolute;

		&:nth-child(1) {
			top: 0;
			left: 0;
			rotate: 90deg;
		}

		&:nth-child(2) {
			top: 0;
			right: 0;
			rotate: 180deg;
		}

		&:nth-child(3) {
			bottom: 0;
			left: 0;
		}

		&:nth-child(4) {
			bottom: 0;
			right: 0;
			rotate: -90deg;
		}
	}
`
